<template>
    <div>
        <b-modal :id="modalId"
            modal-class="modal-draw-delivery"
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-head">
                    {{headline}}
                </div>
                <div class="modal-base-body">
                    <p id="privilege_lbl"
                        class="draw-delivery-txt"
                        v-if="isPrivilegeMessage"
                        v-html="privilegeMessage"></p>
                    <p id="delivery_lbl"
                        class="draw-delivery-txt"
                        v-if="isDelivery"
                        v-html="deliveryMessage"></p>
                </div>
                <div class="modal-base-footer">
                    <div id="draw_delivery_footer_wrapper">
                        <div id="draw_delivery_bzbslogo">
                            <img src="@/assets/bzbslogo/buzzebees-logo-dark.svg"/>
                        </div>
                    </div>
                    <div class="text-center">
                        <button class="btn btn-secondary" @click="hide()">Close</button>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Vue from 'vue';
import Moment from 'moment';
//helper
import Locale from '@/helper/locale/Locale.js';
import Util from '@/helper/Utility.js';

export default {
    name: 'DrawDeliveryModal.vue',
    props: {
        controller: Object,
        modalId: String
    },
    data: function () {
        return {
            lbl: Locale.getLbl(),

            drawDeliveryModel: {},
            tag: null,

            headline: '',
            deliveryMessage: '',
            isDelivery: false,

            privilegeMessage: '',
            isPrivilegeMessage: false,

            busModal: null
        };
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
    },
    methods: {
        close: function () {
            this.hide();
        },
        initial: function () {
            if(this.drawDeliveryModel.privilegeMessage) {
                this.isPrivilegeMessage = true;
                this.privilegeMessage= this.drawDeliveryModel.privilegeMessage;
            } else {
                if(this.drawDeliveryModel.delivered == true) {
                    this.isDelivery = true;
                    this.deliveryMessage = this.lbl.serial.delivery;
                }

                if(this.drawDeliveryModel.type == Vue.CampaignType.Draw) {
                    this.isPrivilegeMessage = true;
                    this.privilegeMessage = this.getDrawMessage();
                }
            }

            this.$bvModal.show(this.modalId);
        },
        getDrawMessage: function () {
            var expireDate = this.drawDeliveryModel.campaignExpiredTimestamp;
            var result = Moment.unix(expireDate).utc();
            var year = result.format('YYYY');
            if (Locale.getLocaleCode() === 1054) year = result.get('year') + 543;

            var day = result.format('DD');
            var month = result.format('MM');
            var date = `${day} ${month} ${year} - ${result.format('HH:mm')}`;

            return Util.stringFormat(this.lbl.serial.draw, date);
        },
        show: function (config) {
            this.drawDeliveryModel = config.drawDeliveryModel;
            this.tag = config.tag;

            this.initial();
        },
        hide: function () {
            this.$bvModal.hide(this.modalId);
        }
    }
}
</script>
<style lang="scss" scoped>
.draw-delivery-txt {
    text-align: center;
}
#draw_delivery_footer_wrapper {
    padding: {
        top: 20px;
        left: 25px;
        right: 25px;
        bottom: 20px;
    };

    #draw_delivery_bzbslogo {
        img {
            display: block;
            height: 20px;
            margin: {
                left: auto;
                right: auto;
            };
        }
    }
}
</style>
<style lang="scss">
@import "@/style/base/base.scss";
@import "@/style/modal.scss";
.modal-draw-delivery {
    @extend %modal-base;
}
</style>
